import React from "react";
import Footer from "../components/Footer";
import '../styles/Contact.css';  // Import the CSS file

const Contact = () => {
  return (
    <div>
      {/* Header Section */}
      <header className="contact-header">
        <h1>Contact Us</h1>
        <p>Have questions or need assistance? We’re here to help.</p>
      </header>
      
      {/* Careers Section */}
      <div className="contact-careers">
        <h2>Looking to Apply?</h2>
        <p>
          We’re always looking for talented individuals to join our team. Check out our{" "}
          <a href="/careers">Careers</a> page to apply now.
        </p>
      </div>

     {/* Contact Section */}
     <section className="contact-section">
        {/* Contact Form */}
        <form
          action="https://formspree.io/f/xjkypnjb"
          method="POST"
          className="contact-form"
        >
          <h2>Get in Touch</h2>
          <input type="hidden" name="_captcha" value="false"></input>
          <label>
            Name:
            <input type="text" name="name" required />
          </label>
          <label>
            Email:
            <input type="email" name="email" required />
          </label>
          <label>
            Message:
            <textarea name="message" required></textarea>
          </label>
          <button type="submit">Send Message</button>
        </form>

        {/* Address Section */}
        <div className="contact-address">
          <h2>Our Office</h2>
          <p>
          16 Reunion Loop NW,<br />
           Airdrie, Alberta, T4B 4J5
           <br />
            Phone: +1 (825) 882-8258<br />
            Email: <a href="mailto:info@westfieldtransport.ca">info@westfieldtransport.ca</a>
          </p>
        </div>

        {/* Google Map */}
        <div className="contact-map">
  <h2>Find Us</h2>
  <iframe
    title="Westfield Transport office location map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.4674302038975!2d-114.04626582339222!3d51.30252407176758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53715f39c1746985%3A0x12cd54c60705e79b!2s16%20Reunion%20Lp%20NW%2C%20Airdrie%2C%20AB%20T4B%204J5!5e0!3m2!1sen!2sca!4v1747615177129!5m2!1sen!2sca"
    width="100%"
    height="300"
    style={{ border: "0", borderRadius: "8px" }}
    allowFullScreen=""
    loading="lazy"
  ></iframe>
</div>

      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contact;
